const prefix = 'NOTE';
const template_prefix = 'NOTE_TEMPLATE';

export const GET_CURRENT_NOTE = Symbol(`${prefix}/GET_CURRENT_NOTE`);
export const GET_NOTE_SUCCESS = Symbol(`${prefix}/GET_NOTE_SUCCESS`);
export const GET_NOTE_FAIL = Symbol(`${prefix}/GET_NOTE_FAIL`);

export const CREATE_NOTE = Symbol(`${prefix}/CREATE_NOTE`);
export const CREATE_NOTE_SUCCESS = Symbol(`${prefix}/CREATE_NOTE_SUCCESS`);
export const CREATE_NOTE_FAIL = Symbol(`${prefix}/CREATE_NOTE_FAIL`);

export const DUPLICATE_NOTE = Symbol(`${prefix}/DUPLICATE_NOTE`);
export const DUPLICATE_NOTE_SUCCESS = Symbol(`${prefix}/DUPLICATE_NOTE_SUCCESS`);
export const DUPLICATE_NOTE_FAIL = Symbol(`${prefix}/DUPLICATE_NOTE_FAIL`);

export const UPDATE_NOTE = Symbol(`${prefix}/UPDATE_NOTE`);
export const UPDATE_NOTE_SUCCESS = Symbol(`${prefix}/UPDATE_NOTE_SUCCESS`);
export const UPDATE_NOTE_FAIL = Symbol(`${prefix}/UPDATE_NOTE_FAIL`);

export const DELETE_NOTE = Symbol(`${prefix}/DELETE_NOTE`);
export const DELETE_NOTE_SUCCESS = Symbol(`${prefix}/DELETE_NOTE_SUCCESS`);
export const DELETE_NOTE_FAIL = Symbol(`${prefix}/DELETE_NOTE_FAIL`);

export const DOWNLOAD_START = Symbol(`${prefix}/DOWNLOAD_START`);
export const DOWNLOAD_SUCCESS = Symbol(`${prefix}/DOWNLOAD_SUCCESS`);
export const DOWNLOAD_FAIL = Symbol(`${prefix}/DOWNLOAD_FAIL`);

export const BLOCK_NOTE = Symbol(`${prefix}/BLOCK_NOTE`);
export const BLOCK_NOTE_SUCCESS = Symbol(`${prefix}/BLOCK_NOTE_SUCCESS`);
export const BLOCK_NOTE_FAIL = Symbol(`${prefix}/BLOCK_NOTE_FAIL`);

export const UNBLOCK_NOTE = Symbol(`${prefix}/UNBLOCK_NOTE`);
export const UNBLOCK_NOTE_SUCCESS = Symbol(`${prefix}/UNBLOCK_NOTE_SUCCESS`);
export const UNBLOCK_NOTE_FAIL = Symbol(`${prefix}/UNBLOCK_NOTE_FAIL`);

export const GET_NOTE_BLOCKED_STATUS = Symbol(`${prefix}/GET_NOTE_BLOCKED_STATUS_STATUS`);
export const GET_NOTE_BLOCKED_STATUS_SUCCESS = Symbol(`${prefix}/GET_NOTE_BLOCKED_STATUS_SUCCESS`);
export const GET_NOTE_BLOCKED_STATUS_FAIL = Symbol(`${prefix}/GET_NOTE_BLOCKED_STATUS_FAIL`);

export const NOTE_FILE_UPLOAD = Symbol(`${prefix}/NOTE_FILE_UPLOAD`);
export const NOTE_FILE_UPLOAD_SUCCESS = Symbol(`${prefix}/NOTE_FILE_UPLOAD_SUCCESS`);
export const NOTE_FILE_UPLOAD_FAIL = Symbol(`${prefix}/NOTE_FILE_UPLOAD_FAIL`);

export const NOTE_FILE_REMOVE = Symbol(`${prefix}/NOTE_FILE_REMOVE`);
export const NOTE_FILE_REMOVE_SUCCESS = Symbol(`${prefix}/NOTE_FILE_REMOVE_SUCCESS`);
export const NOTE_FILE_REMOVE_FAIL = Symbol(`${prefix}/NOTE_FILE_REMOVE_FAIL`);

export const NOTE_TEMPLATE_FILE_REMOVE = Symbol(`${prefix}/NOTE_TEMPLATE_FILE_REMOVE`);
export const NOTE_TEMPLATE_FILE_REMOVE_SUCCESS = Symbol(`${prefix}/NOTE_TEMPLATE_FILE_REMOVE_SUCCESS`);
export const NOTE_TEMPLATE_FILE_REMOVE_FAIL = Symbol(`${prefix}/NOTE_TEMPLATE_FILE_REMOVE_FAIL`);

export const NOTE_ERROR_MODAL_CLOSE = Symbol(`${prefix}/NOTE_ERROR_MODAL_CLOSE`);

export const GET_CURRENT_TEMPLATE = Symbol(`${template_prefix}/GET_CURRENT_TEMPLATE`);
export const GET_TEMPLATE_SUCCESS = Symbol(`${template_prefix}/GET_TEMPLATE_SUCCESS`);
export const GET_TEMPLATE_FAIL = Symbol(`${template_prefix}/GET_TEMPLATE_FAIL`);

export const CREATE_TEMPLATE = Symbol(`${template_prefix}/CREATE_TEMPLATE`);
export const CREATE_TEMPLATE_SUCCESS = Symbol(`${template_prefix}/CREATE_TEMPLATE_SUCCESS`);
export const CREATE_TEMPLATE_FAIL = Symbol(`${template_prefix}/CREATE_TEMPLATE_FAIL`);

export const DUPLICATE_TEMPLATE = Symbol(`${template_prefix}/DUPLICATE_TEMPLATE`);
export const DUPLICATE_TEMPLATE_SUCCESS = Symbol(`${template_prefix}/DUPLICATE_TEMPLATE_SUCCESS`);
export const DUPLICATE_TEMPLATE_FAIL = Symbol(`${template_prefix}/DUPLICATE_TEMPLATE_FAIL`);

export const UPDATE_TEMPLATE = Symbol(`${template_prefix}/UPDATE_TEMPLATE`);
export const UPDATE_TEMPLATE_SUCCESS = Symbol(`${template_prefix}/UPDATE_TEMPLATE_SUCCESS`);
export const UPDATE_TEMPLATE_FAIL = Symbol(`${template_prefix}/UPDATE_TEMPLATE_FAIL`);

export const DELETE_TEMPLATE = Symbol(`${template_prefix}/DELETE_TEMPLATE`);
export const DELETE_TEMPLATE_SUCCESS = Symbol(`${template_prefix}/DELETE_TEMPLATE_SUCCESS`);
export const DELETE_TEMPLATE_FAIL = Symbol(`${template_prefix}/DELETE_TEMPLATE_FAIL`);

export const UPDATE_USE_FILE_UPLOAD = Symbol(`${template_prefix}/UPDATE_USE_FILE_UPLOAD`);
export const UPDATE_USE_FILE_UPLOAD_SUCCESS = Symbol(`${template_prefix}/UPDATE_USE_FILE_UPLOAD_SUCCESS`);
export const UPDATE_USE_FILE_UPLOAD_FAIL = Symbol(`${template_prefix}/UPDATE_USE_FILE_UPLOAD_FAIL`);

export const UPDATE_USE_TEMPLATE_FILE_UPLOAD = Symbol(`${template_prefix}/UPDATE_USE_TEMPLATE_FILE_UPLOAD`);
export const UPDATE_USE_TEMPLATE_FILE_UPLOAD_SUCCESS =
  Symbol(`${template_prefix}/UPDATE_USE_TEMPLATE_FILE_UPLOAD_SUCCESS`);
export const UPDATE_USE_TEMPLATE_FILE_UPLOAD_FAIL = Symbol(`${template_prefix}/UPDATE_USE_TEMPLATE_FILE_UPLOAD_FAIL`);

export const RESTRICTIONS_NOTE = Symbol(`${prefix}/RESTRICTIONS_NOTE`);
export const RESTRICTIONS_NOTE_SUCCESS = Symbol(`${prefix}/RESTRICTIONS_NOTE_SUCCESS`);
export const RESTRICTIONS_NOTE_FAIL = Symbol(`${prefix}/RESTRICTIONS_NOTE_FAIL`);
